<b3-modal [open]="true" overlay size="lg" (b3-close)="close()">
  <b3-modal-header
    [heading]="title"
    aria-level="2"
    close-aria-label="Fechar"
    (b3-close)="close()">
  </b3-modal-header>

  <b3-modal-body>
    <div class="operation-detail-modal__tables">
      <div class="detail-table" *ngFor="let section of sections">
        <div class="detail-table__row detail-table__row--header">
          <div class="detail-table__cell detail-table__cell--header"
            *ngFor="let column of section.columns"
            [style.flex]="column.flex ? column.flex + ' 1 0' : '1 1 0'">
            {{ column.label }}
          </div>
        </div>
        <div class="detail-table__row detail-table__row--body">
          <div class="detail-table__cell"
            *ngFor="let column of section.columns"
            [style.flex]="column.flex ? column.flex + ' 1 0' : '1 1 0'">
            <a *ngIf="column.isLink && column.value" class="detail-table__link"
              [href]="column.value" target="_blank" rel="noopener noreferrer">{{ column.value }}</a>
            <span *ngIf="!column.isLink || !column.value">{{ column.value ?? '' }}</span>
          </div>
        </div>
      </div>
    </div>
  </b3-modal-body>

  <b3-modal-footer>
    <b3-button type="button" variant="filled" tone="default" (b3-click)="close()">
      Entendi
    </b3-button>
  </b3-modal-footer>
</b3-modal>
